import { frontendURL } from 'dashboard/helper/URLHelper';

import RmsPropertiesIndex from './Index.vue';

// "RMS - Listagem de imóveis": embeds the RMS property listing in the dashboard.
// The account attribute is enforced by the page after the account is loaded;
// route permissions keep the listing restricted to account administrators.
const RMS_PROPERTIES_PERMISSIONS = ['administrator'];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/properties'),
      name: 'rms_properties_index',
      meta: {
        permissions: RMS_PROPERTIES_PERMISSIONS,
      },
      component: RmsPropertiesIndex,
    },
  ],
};
